import React, { useState, useEffect } from 'react';
import PageBanner from '../components/PageBanner';
import './Contact.css';

// =========================================================================
// 🌐 [LINE 6] BACKEND API ENDPOINT:
// Namecheap cPanel හි ඇති backend/contact.php API එකට මෙතැනින් සම්බන්ධ වේ:
const BACKEND_API_URL = '/backend/contact.php';
// =========================================================================

const Contact = () => {
  useEffect(() => {
    document.title = 'Contact - SOFTORA Technologies';
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: 'Web Application Development',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [activeFaq, setActiveFaq] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorMessage('');

    try {
      const response = await fetch(BACKEND_API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          service: formData.service,
          message: formData.message
        })
      });

      const result = await response.json();
      if (response.ok && (result.success === true || result.success === "true")) {
        setSubmitted(true);
      } else {
        setErrorMessage(result.message || "Message could not be sent. Please check server settings or message via WhatsApp.");
      }
    } catch (err) {
      console.error("API Error:", err);
      setErrorMessage("Could not connect to backend/contact.php API. (cPanel එකට upload කළ පසු මෙය ස්වයංක්‍රීයව ක්‍රියාත්මක වේ).");
    } finally {
      setIsSubmitting(false);
    }
  };

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  const faqs = [
    {
      q: "How does Softora manage project delivery and communication?",
      a: "We adhere strictly to agile project management with weekly milestone check-ins, sprint demos, and direct chat access (WhatsApp/Slack) so you have continuous real-time transparency."
    },
    {
      q: "Do I get full ownership of the source code and IP?",
      a: "Yes, 100%. Upon completion and handover, all intellectual property, git repositories, codebases, and credentials are completely transferred to you with zero vendor lock-in."
    },
    {
      q: "Can Softora collaborate with international clients across different timezones?",
      a: "Absolutely! We routinely collaborate with startups and businesses across Sri Lanka, the US, UK, Australia, and Asia, adapting our meeting schedules to match your preferred working hours."
    },
    {
      q: "What warranty and post-launch maintenance do you offer?",
      a: "Every project includes a post-launch warranty period for bug fixes and stability checks, as well as optional retainer support for continuous feature development and server monitoring."
    },
    {
      q: "How quickly can our project start after the initial call?",
      a: "Following our initial discovery session and proposal agreement, our engineering team can typically begin architecture & UI wireframing within 48 to 72 hours."
    }
  ];

  return (
    <div className="contact-page">
      <PageBanner
        badge="GET IN TOUCH"
        title="Let's Build Something"
        highlight="Extraordinary Together"
        subtitle="Have a project in mind, need technical consulting, or looking for dedicated engineers? Contact Softora today for a free proposal."
      />

      {/* Contact Cards Strip */}
      <section className="contact-info-section">
        <div className="contact-page-container">
          <div className="contact-info-cards-grid">
            
            <div className="contact-method-card">
              <div className="method-icon-wrap">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
                </svg>
              </div>
              <span className="method-label">CHAT ON WHATSAPP</span>
              <h3 className="method-value">+94 78 545 2899</h3>
              <p className="method-desc">Instant replies for immediate queries and quotes.</p>
              <a href="https://wa.me/94785452899" target="_blank" rel="noopener noreferrer" className="method-link">
                Message Us Now →
              </a>
            </div>

            <div className="contact-method-card">
              <div className="method-icon-wrap">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              </div>
              <span className="method-label">EMAIL US</span>
              <h3 className="method-value">support@getsoftora.com</h3>
              <p className="method-desc">Send us your RFP, specifications, or documents.</p>
              <a href="mailto:Contact@SoftoraTech.com" className="method-link">
                Send An Email →
              </a>
            </div>

            <div className="contact-method-card">
              <div className="method-icon-wrap">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12 6 12 12 16 14"/>
                </svg>
              </div>
              <span className="method-label">HOURS OF OPERATION</span>
              <h3 className="method-value">Mon - Sat: 9 AM - 7 PM</h3>
              <p className="method-desc">Flexible scheduling for global timezones.</p>
              <span className="method-status">Online & Available</span>
            </div>

          </div>
        </div>
      </section>

      {/* Main Form Section */}
      <section className="contact-form-section">
        <div className="contact-page-container">
          <div className="contact-form-layout">
            
            <div className="form-left-col">
              <span className="section-eyebrow">INQUIRY FORM</span>
              <h2 className="form-heading">
                Tell Us About Your <span className="title-gradient">Project</span>
              </h2>
              <p className="form-subtext">
                Fill in the details below. Our technical leads will review your requirements and reach out within 24 hours with an actionable roadmap.
              </p>

              <div className="form-benefits-list">
                <div className="benefit-item">
                  <span className="benefit-check">✓</span>
                  <span>Free Initial Technical Feasibility Review</span>
                </div>
                <div className="benefit-item">
                  <span className="benefit-check">✓</span>
                  <span>Transparent Milestone & Pricing Estimates</span>
                </div>
                <div className="benefit-item">
                  <span className="benefit-check">✓</span>
                  <span>Non-Disclosure Agreement (NDA) Protected</span>
                </div>
              </div>
            </div>

            <div className="form-right-card">
              {submitted ? (
                <div className="form-success-box">
                  <div className="success-icon">✅</div>
                  <h3>Inquiry Sent Directly to Our Email!</h3>
                  <p>Thank you, <strong>{formData.name}</strong>! Your project details have been dispatched to our inbox. Our engineering team will review and reply to <strong>{formData.email}</strong> shortly.</p>
                  <button type="button" className="btn-secondary" onClick={() => {
                    setSubmitted(false);
                    setFormData({
                      name: '',
                      email: '',
                      phone: '',
                      service: 'Web Application Development',
                      message: ''
                    });
                  }}>
                    Send Another Message
                  </button>
                </div>
              ) : (
                <form className="project-inquiry-form" onSubmit={handleSubmit}>
                  <div className="form-row">
                    <div className="form-field">
                      <label>Your Name *</label>
                      <input
                        type="text"
                        name="name"
                        placeholder="e.g. Kasun Perera"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-field">
                      <label>Email Address *</label>
                      <input
                        type="email"
                        name="email"
                        placeholder="kasun@example.com"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-field">
                      <label>Phone / WhatsApp Number</label>
                      <input
                        type="text"
                        name="phone"
                        placeholder="+94 7x xxx xxxx"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-field">
                      <label>Service Needed *</label>
                      <select name="service" value={formData.service} onChange={handleChange}>
                        <option value="Web Application Development">Web Application Development</option>
                        <option value="Mobile App Development">Mobile App Development (Flutter)</option>
                        <option value="Backend & Cloud Infrastructure">Backend & Cloud Infrastructure</option>
                        <option value="AI Integration & Automation">AI Integration & Automation</option>
                        <option value="IT Architecture & Consulting">IT Architecture & Consulting</option>
                        <option value="Full Product Development">Full Product Development (Web + Mobile)</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-field">
                    <label>Project Details / Requirements *</label>
                    <textarea
                      name="message"
                      rows="4"
                      placeholder="Briefly describe what you want to build, target audience, timeline, or key features..."
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>

                  {errorMessage && (
                    <div className="form-error-msg">
                      ⚠️ {errorMessage}
                    </div>
                  )}

                  <button type="submit" className="submit-form-btn" disabled={isSubmitting}>
                    <span>{isSubmitting ? 'SENDING TO EMAIL...' : 'CONNECT & SEND INQUIRY'}</span>
                    <span className="btn-arrow">{isSubmitting ? '⏳' : '→'}</span>
                  </button>
                </form>
              )}
            </div>

          </div>
        </div>
      </section>

      {/* FAQ Accordion Section */}
      <section className="contact-faq-section">
        <div className="contact-page-container">
          <div className="text-center section-header">
            <span className="section-eyebrow">COMMON QUESTIONS</span>
            <h2 className="section-title">
              Frequently Asked <span className="title-gradient">Questions</span>
            </h2>
            <p className="section-subtitle">
              Answers to common inquiries regarding our software development process and engagement models.
            </p>
          </div>

          <div className="faq-accordion">
            {faqs.map((faq, fIdx) => (
              <div
                key={fIdx}
                className={`faq-item ${activeFaq === fIdx ? 'open' : ''}`}
                onClick={() => toggleFaq(fIdx)}
              >
                <div className="faq-question">
                  <span>{faq.q}</span>
                  <span className="faq-toggle-icon">{activeFaq === fIdx ? '−' : '+'}</span>
                </div>
                {activeFaq === fIdx && (
                  <div className="faq-answer">
                    <p>{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
